import { Elements, useElements, useStripe, PaymentElement, CardElement } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import "./Update.css";
import NavbarLogo from "../../Assets/Logo";
import toast from "react-hot-toast";

function UpdateCard() {
    const { userId } = useContext(AuthContext);
    const [stripePromise, setStripePromise] = useState(null);

    useEffect(() => {
        const initializeStripe = async () => {
            const stripeKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

            if (!stripeKey) {
                console.error("Stripe public key is missing.");
                return;
            }
            const stripe = await loadStripe(stripeKey);
            setStripePromise(stripe);
        };
        initializeStripe();
    }, [userId]);

    if (!stripePromise ) {
        return <div>Loading Stripe...</div>;
    }

    return (
        <Elements stripe={stripePromise}>
            <CheckoutForm />
        </Elements>
    );
}
export default UpdateCard;



export function CheckoutForm() {
    const [processing, setProcessing] = useState('');
    const [disabled, setDisabled] = useState(true);
    const [succeeded, setSucceeded] = useState(false);
    const [error, setError] = useState(null);
    const { userId } = useContext(AuthContext);
    const stripe = useStripe();
    const elements = useElements();
    const access_token = localStorage.getItem("token");
    const cardStyle = {
        style: {
            base: {
                color: "#32325d",
                fontFamily: 'Arial, sans-serif',
                fontSmoothing: "antialiased",
                fontSize: "16px",
                "::placeholder": {
                    color: "#32325d",
                },
            },
            invalid: {
                fontFamily: 'Arial, sans-serif',
                color: "#fa755a",
                iconColor: "#fa755a",
            },
        },
    };



    const handleChange = (event) => {
        // Update state based on CardElement changes
        setDisabled(event.empty);
        setError(event.error ? event.error.message : "");
    };

    const handleLoadError = (event) => {
        console.error("Error loading CardElement:", event);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
    
        if (!stripe || !elements) {
            toast.error("Stripe.js has not loaded yet.");
            return;
        }
    
        const cardElement = elements.getElement(CardElement);
        if (!cardElement) {
            toast.error("PaymentElement not loaded.");
            return;
        }
    
        const updatePaymentMethodPromise = (async () => {
            // Create the payment method
            const { error, paymentMethod } = await stripe.createPaymentMethod({
                type: "card",
                card: cardElement,
            });
    
            if (error) {
                throw new Error(error.message);
            }
    
            // Send the payment method ID to the backend
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/update_payment_method`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${access_token}`,
                  },
                body: JSON.stringify({
                    user_id: userId,
                    payment_method_id: paymentMethod.id,
                }),
            });
    
            const data = await response.json();
    
            if (!data.success) {
                throw new Error(data.message || "Failed to update payment method.");
            }
            cardElement.clear();
    
            return "Payment method updated successfully!";
        })();
    
        // Use `toast.promise` for notifications
        toast.promise(updatePaymentMethodPromise, {
            loading: "Updating payment method...",
            success: (message) => message,
            error: (err) => err.message || "An error occurred while updating payment method.",
        });
    };
    

    return (
        <div className="paymentForm flex justify-center py-20 ">
            <form
                id="payment-form"
                className="2xl:w-1/2 xl:w-1/2 lg:w-1/2 md:w-2/3 dark:bg-[#222a32]"
                onSubmit={handleSubmit}
            >
                <div className="flex items-center justify-center mb-6">
                    <NavbarLogo />
                </div>
                <h2 className="text-center text-xl font-bold mb-4 dark:text-white">Update Card</h2>
                <p className="text-center text-gray-600 mb-8 dark:text-gray-300">Enter Card Details to update in stripe</p>
                <CardElement
                    id="card-element"
                    options={{ style: cardStyle, hidePostalCode: true }}
                    onChange={handleChange}
                    onLoadError={handleLoadError}
                />
                <button
                    disabled={processing || disabled || succeeded}
                    id="submit"
                    className="btn-primary bg-black text-white w-full rounded-b-md p-2 mt-4"
                >
                    <span id="button-text">
                        {processing ? (
                            <div className="spinner" id="spinner"></div>
                        ) : (
                            "Update Now"
                        )}
                    </span>
                </button>
                {/* Display errors */}
                {error && (
                    <div className="card-error text-red-500 mt-2" role="alert">
                        {error}
                    </div>
                )}
                {/* Success message */}
                <p className={succeeded ? "result-message" : "result-message hidden"}>
                    Payment succeeded, see the result in your
                    <a
                        href={`https://dashboard.stripe.com/test/payments`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {" "}
                        Stripe dashboard.
                    </a>{" "}
                    Refresh the page to pay again.
                </p>
            </form>
        </div>
    );
}
